import * as React from 'react';
import { Link } from 'react-router-dom';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import { Button } from '../../../components/Button/Button';
import * as Yup from 'yup';
import { checkAvailabilitySchoolUsers } from '../../../services/public/register';

import '../SchoolAppLogin2/SchoolAppLoginForm.scss';

interface Props {
  onSubmit: (data: { email: string }) => void;
  redirectToLoginPage: () => void;
}

export function SchoolAppResetPasswordForm2(props: Props) {
  const { onSubmit } = props;

  const ResetPasswordSchema = Yup.object().shape({
    email: Yup.string()
      .required('Required')
      .email('Must be valid email')
      .test('email', 'Email not found', value => {
        if (!value) return false;
        return checkAvailabilitySchoolUsers({ email: value }).then(res => !res.isAvailable);
      }),
  });

  return (
    <div className="container">
      <div className="row">
        <div className="col-md-12">
          <div className="bFormSignIn">
            <div className="eFormSignIn">
              <Formik
                initialValues={{ email: '' }}
                validationSchema={ResetPasswordSchema}
                onSubmit={onSubmit}
                validateOnBlur={false}
                validateOnChange={false}
              >
                {({ handleSubmit, isSubmitting }) => (
                  <Form onSubmit={handleSubmit}>
                    <div className="eFormSignInImg">
                      <img src="/dist/images/logo.png" alt="Logo" />
                    </div>

                    <h1 className="h3 mb-3 mt-3 font-weight-normal">Reset password</h1>

                    <div className="mb-3">Please enter the email address you used to create the account.</div>

                    <div className="form-group">
                      <Field
                        type="email"
                        name="email"
                        id="reset_email"
                        className="form-control"
                        placeholder="Email address"
                        autoComplete="email"
                      />
                      <ErrorMessage component="div" className="alert alert-danger mt-2" name="email" />
                    </div>

                    <button
                      className="btn btn-lg btn-primary btn-block mt-2"
                      type="submit"
                      disabled={isSubmitting}
                      id="reset_submit"
                    >
                      Send reset link
                    </button>

                    <div className="eFormSignInResetPassword mt-2">
                      <Link className="nav-link" to={{ pathname: '/login' }}>
                        Back to sign in
                      </Link>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
